const translations = {
  "en": {
    "expires today": "expires today",
    "Payment Failed": "Payment Failed",
    "Update payment method": "Update payment method",
    "Upgrade": "Upgrade",
    "View Details": "View Details",
    "We couldn't process your automatic renewal payment. Verify your payment method to prevent service interruptions.": "We couldn't process your automatic renewal payment. Verify your payment method to prevent service interruptions.",
    "Your Plan ends in %{var0} days.": "Your Plan ends in %{var0} days."
  },
  "zh-tw": {
    "expires today": "今天到期",
    "Payment Failed": "付款失敗",
    "Update payment method": "更新付款方式",
    "Upgrade": "升級",
    "View Details": "查看詳情",
    "We couldn't process your automatic renewal payment. Verify your payment method to prevent service interruptions.": "我們無法處理你的自動續訂付款。請確認你的付款方式，以避免服務中斷。",
    "Your Plan ends in %{var0} days.": "你的會員將在 %{var0} 天後結束。"
  }
};

export default translations;
